import UserGroupControls from './UserGroupControls';
import UserGroupsBreadcrumbs from './UserGroupsBreadcrumbs';

import classes from './userGroupsTable.module.css';

const styles = {
  breadcrumb: {
    display: 'flex',
    flexFlow: 'row wrap',
    flex: 'auto',
    alignItems: 'flex-start',
    width: '45rem',
    height: '3.125rem',
  },
};

const UserGroupsHeader = () => {
  return (
    <div className={classes.headerContainer}>
      <div style={styles.breadcrumb}>
        <UserGroupsBreadcrumbs />
      </div>
      <UserGroupControls />
    </div>
  );
};

export default UserGroupsHeader;
